import ShopCheckoutOrderResourceModel from '../../generated/types/model/resource/ShopCheckoutOrderResourceModel';

export default class ShopCheckoutOrderResourceViewModel extends ShopCheckoutOrderResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
